import script from "./KDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./KDropdown.vue?vue&type=script&setup=true&lang=js"

import "./KDropdown.vue?vue&type=style&index=0&id=462b495a&lang=sass"

const __exports__ = script;

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QField from 'quasar/src/components/field/QField.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';import Scroll from 'quasar/src/directives/scroll/Scroll.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QItem,QItemSection,QItemLabel,QSeparator,QField,QSpinner,QIcon});qInstall(script, 'directives', {Scroll});
